module.exports = __webpack_public_path__ + "img/line-3-4.svg";